export const META_TAG_SCOPE_ROOT = "root";
export const META_TAG_SCOPE_BETTING = "betting";
export const META_TAG_SCOPE_CASINO = "casino";
export const META_TAG_SCOPE_SPORT = "sport";
export const META_TAG_SCOPE_REGION = "region";
export const META_TAG_SCOPE_LEAGUE = "league";

export const META_TAG_SCOPES = [
  META_TAG_SCOPE_ROOT,
  META_TAG_SCOPE_BETTING,
  META_TAG_SCOPE_CASINO,
  META_TAG_SCOPE_SPORT,
  META_TAG_SCOPE_REGION,
  META_TAG_SCOPE_LEAGUE,
];

export const META_TAG_SCOPES_WITHOUT_IDENTIFIERS = [
  META_TAG_SCOPE_ROOT,
  META_TAG_SCOPE_BETTING,
  META_TAG_SCOPE_CASINO,
];

export const isScopeWithoutIdentifiers = (scope) => {
  return META_TAG_SCOPES_WITHOUT_IDENTIFIERS.includes(scope);
};
